import React, { useEffect, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import {
  Container,
  CustomInput,
  EndLabel,
  HelperText,
  InputContainer,
  Label,
} from "../styles";
import useCourses from "./useCourses";
import { CircularProgress, TextField } from "@material-ui/core";

export default function CoursesSelect({
  name,
  label,
  placeholder,
  courses,
  onChangeCourses,
  helperText,
  errorMessage = "",
  fullWidth = false,
  multiple,
  ...props
}) {
  const [search, setSearch] = useState("");

  const { data, loading } = useCourses({ search });

  const options = data?.map((item) => {
    return {
      id: item.id,
      name: item.name,
    };
  });

  return (
    <Container fullWidth={fullWidth}>
      <Label htmlFor={name}>{label}</Label>
      <Autocomplete
        filterSelectedOptions
        fullWidth={fullWidth}
        multiple={multiple}
        size="small"
        options={options}
        loading={loading}
        getOptionSelected={(option, value) => option.id === value.id}
        getOptionLabel={(option) => `[${option.id}] ${option.name}`}
        loadingText="Buscando produtos"
        noOptionsText="Nenhum produto encontrado"
        value={courses}
        onChange={(e, newValue) => onChangeCourses(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Selecione o produto"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
      {helperText && !errorMessage && <HelperText>{helperText}</HelperText>}
      {!!errorMessage && (
        <HelperText isError={!!errorMessage}>{errorMessage}</HelperText>
      )}
    </Container>
  );
}
